module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-douwe-egberts-03.a70971d2.jpg";